import { Endpoints } from 'Roblox';

export const getAvatarThumbnail3dJsonUrl = (userId: number) =>
  Endpoints.getAbsoluteUrl(`/avatar-thumbnail-3d/json?userId=${userId}`);
